/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name arrayAverage
 * @description calculates the sum of one column divided by the sum of another column
 */
angular.module('mercury.filters.arrayaverage', [])
.filter('arrayAverage', function() {
  return function(arr, numeratorKey, denominatorKey) {
    if (!arr) {
      return 0;
    }

    var numerator = 0;
    var denominator = 0;
    for (var i = 0; i < arr.length; i++) {
      numerator += arr[i][numeratorKey];
      denominator += arr[i][denominatorKey];
    }

    return denominator == 0 ? 0 : (numerator / denominator);
  };
});
